import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Target, Sparkles, Globe, Shield, Zap, Layers, Users } from 'lucide-react';

export default function CompanyVision() {
  return (
    <SubpageTemplate 
      title="The Vision"
      subtitle="Democratizing Capability"
      description="We are entering a new era of software. One where the barrier to creation is not syntax, but imagination. Yacht Labs is building the infrastructure for this transition."
      icon={Target}
      features={[
        {
          title: "Code as a Commodity",
          description: "We believe writing code should be automated so builders can focus on product market fit.",
          icon: Zap
        },
        {
          title: "The Human Element",
          description: "AI is the engine, but the human is the navigator. We build tools that amplify human intent.",
          icon: Users
        },
        {
          title: "Open Ecosystem",
          description: "Protecting the future of software by ensuring tools remain flexible and non-proprietary.",
          icon: Globe
        }
      ]}
    />
  );
}
